// shouldShowImagery.js — Ticket 02: satellite imagery layer (NASA GIBS).
//
// Seam: the pure "should the imagery layer be visible right now?" decision, factored out of
// MapEditorModal's DTG-cursor-driven wiring so it's trivially unit-testable — no OL, no
// network, no React. Given a bbox + DTG + any `ImageryProvider`-shaped object (see
// `./ImageryProvider.js`), it delegates to `provider.getCoverage(bbox, dtg)` and returns
// `hasCoverage`, coerced to a strict boolean. Deliberately purely a *decision* helper (not a
// data-fetcher): callers that also need the `tileUrlTemplate` to render should call
// `provider.getCoverage` directly (as `MapEditorModal.jsx` does) rather than calling this
// function and then re-deriving the template separately.
//
// No zoom-level gating by design (per the ticket): the only input besides bbox/dtg is the
// provider's own coverage answer.

/**
 * @param {[number, number, number, number]|null} bbox - [minLon, minLat, maxLon, maxLat],
 *   EPSG:4326. May be `null` if the caller doesn't have a viewport bbox yet.
 * @param {number|Date|import('dayjs').Dayjs} dtg - the DTG to evaluate coverage at.
 * @param {import('./ImageryProvider').ImageryProvider} provider
 * @returns {boolean} whether imagery should be shown (vs. falling back to the default basemap).
 */
export function shouldShowImagery(bbox, dtg, provider) {
    if (!provider || typeof provider.getCoverage !== 'function') return false;
    const coverage = provider.getCoverage(bbox, dtg);
    return !!(coverage && coverage.hasCoverage);
}

export default shouldShowImagery;
